import { z, ZodType } from 'zod';
import { EntityWithName, entityWithNameSchema } from './entity-with-name';

export type Shift = {
	id: string;
	openingBalance: number;
	closingBalance: number;
	currency: string;
	isActive: boolean;
	owner: EntityWithName;
};

export const shiftSchema: ZodType<Shift> = z.object({
	id: z.string(),
	openingBalance: z.number(),
	closingBalance: z.number(),
	currency: z.string(),
	isActive: z.boolean(),
	owner: entityWithNameSchema,
});
